import departmentsService from './departmentsService'

export default departmentsService



// WEBPACK FOOTER //
// ../src/services/departmentsService/index.js